import { Directive, ElementRef, afterNextRender, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SheetGrabService } from '../services/sheet-grab.service';

// Drag handle of a bottom sheet: the first element of the sheet template.
@Directive({
  selector: '[urbanSheetGrab]',
  standalone: true,
  host: {
    class: 'uvSheetGrab',
    'aria-hidden': 'true'
  }
})
export class SheetGrabDirective {
  constructor() {
    const grab: HTMLElement = inject(ElementRef).nativeElement;
    const ref: MatBottomSheetRef<unknown> = inject(MatBottomSheetRef);
    const sheetGrab: SheetGrabService = inject(SheetGrabService);

    afterNextRender(() => {
      const panel: HTMLElement | null = grab.closest<HTMLElement>('.mat-bottom-sheet-container');

      if (panel) {
        sheetGrab.bind(grab, {
          panel,
          close: () => ref.dismiss(),
          canClose: () => !ref.disableClose
        });
      }
    });
  }
}
